import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const configModule = {
  namespaced: true,
  state: {
    baseUrl: 'https://www.sasmango.com/sas/',
    authors: {},
    socket: null
  },
  mutations: {
    update (state, args) {
      let keys = Object.keys(args)
      for (let i = 0; i < keys.length; i++) {
        let key = keys[i]
        if (key in state) {
          state[key] = args[key]
        }
      }
    }
  },
  getters: {
    get: (state) => (type) => {
      return (type in state) ? state[type] : null
    }
  },
  actions: {
    setSocket (context, newSocket) {
      context.commit('update', {
        socket: newSocket
      })
    }
  }
}

const authorModule = {
  namespaced: true,
  state: {
    id: '',
    userid: '',
    nickname: '',
    authority: [],
    roles: [],
    name: ['', ''],
    belong: '',
    tokens: {
      firebase: '',
      box: ''
    },
    dev: false
  },
  mutations: {
    update (state, req) {
      if ('id' in req) {
        state.id = req.id
      }
      if ('userid' in req) {
        state.userid = req.userid
      }
      if ('nickname' in req) {
        state.nickname = req.nickname
      }
      if ('roles' in req) {
        state.roles.splice(0, state.roles.length)
        for (let i = 0; i < req.roles.length; i++) {
          state.roles.push(req.roles[i])
        }
      }
      if ('authority' in req) {
        state.authority.splice(0, state.authority.length)
        for (let i = 0; i < req.authority.length; i++) {
          state.authority.push(req.authority[i])
        }
      }
      if ('name' in req) {
        state.name.splice(0, 1, (req.name.length > 0) ? req.name[0] : '')
        state.name.splice(1, 1, (req.name.length > 1) ? req.name[1] : '')
      }
      if ('belong' in req) {
        state.belong = req.belong
      }
      if ('tokens' in req) {
        if ('firebase' in req.tokens) {
          state.tokens.firebase = req.tokens.firebase
        }
        if ('box' in req.tokens) {
          state.tokens.box = req.tokens.box
        }
      }
      if ('firebaseToken' in req) {
        state.tokens.firebase = req.firebaseToken
      }
      if ('box' in req) {
        state.tokens.box = req.box
      }
    },
    develop (state, status) {
      state.dev = status
    }
  },
  actions: {
    signin (context, req) {
      return new Promise((resolve) => {
        context.commit('update', req)
        setTimeout(() => {
          resolve('success signin')
        }, 7000)
      })
    }
  },
  getters: {
    get: (state) => (type) => {
      return (type in state) ? state[type] : null
    },
    getAll: (state) => () => {
      return state
    }
  }
}

const clientModule = {
  namespaced: true,
  state: {
    id: '',
    type: '',
    author: {
      id: '',
      name: ['', '']
    },
    name: ['', ''],
    kana: ['', ''],
    lib: {
      media: '',
      profile: '',
      arrange: ''
    }
  },
  mutations: {
    update (state, req) {
      if ('id' in req) {
        state.id = req.id
      }
      if ('type' in req) {
        state.type = req.type
      }
      if ('author' in req) {
        state.author = req.author
      }
      if ('name' in req) {
        state.name.splice(0, 1, (req.name.length > 0) ? req.name[0] : '')
        state.name.splice(1, 1, (req.name.length > 1) ? req.name[1] : '')
      }
      if ('kana' in req) {
        state.kana.splice(0, 1, (req.kana.length > 0) ? req.kana[0] : '')
        state.kana.splice(1, 1, (req.kana.length > 1) ? req.kana[1] : '')
      }
      if ('lib' in req) {
        if ('media' in req.lib) {
          state.lib.media = req.lib.media
        }
        if ('profile' in req.lib) {
          state.lib.profile = req.lib.profile
        }
        if ('arrange' in req.lib) {
          state.lib.arrange = req.lib.arrange
        }
      }
    }
  },
  getters: {
    get: (state) => (type) => {
      return (type in state) ? state[type] : null
    },
    all: (state) => () => {
      return state
    }
  }
}

const loaderModule = {
  namespaced: true,
  state: {
    status: {
      active: false
    },
    message: {
      default: 'データの読み込み中...',
      value: ''
    }
  },
  mutations: {
    open (state, msg) {
      state.message.value = (msg == null) ? state.message.default : msg
      state.status.active = true
    },
    close (state) {
      state.status.active = false
    },
    set (state, msg) {
      state.message.value = msg
    }
  },
  getters: {
    isActive: (state) => () => {
      return state.status.active
    },
    printMessage: (state) => () => {
      return state.message.value
    }
  }
}

const notifierModule = {
  namespaced: true,
  state: {
    items: []
  },
  mutations: {
    add (state, item) {
      state.items.push({
        id: item.id,
        type: item.type ? item.type : '',
        title: item.title ? item.title : '無題',
        message: item.message ? item.message : '',
        progress: item.progress ? item.progress : 0
      })
    },
    update (state, item) {
      if (item.id) {
        let idx = state.items.findIndex(it => {
          return it.id && it.id === item.id
        })
        if (idx >= 0) {
          if ('type' in item) {
            state.items[idx].type = item.type
          }
          if ('title' in item) {
            state.items[idx].title = item.title
          }
          if ('message' in item) {
            state.items[idx].message = item.message
          }
          if ('progress' in item) {
            state.items[idx].progress = item.progress
          }
        }
      }
    },
    close (state, id) {
      let idx = state.items.findIndex(it => {
        return (it.id && it.id === id)
      })
      state.items.splice(idx, 1)
    }
  },
  actions: {
    addAlert (context, item) {
      let uid = new Date().getTime().toString(16) + Math.floor(1000 * Math.random()).toString(16)
      context.commit('add', Object.assign({}, item, {
        id: uid,
        type: 'alert'
      }))
      setTimeout(() => {
        context.commit('close', uid)
      }, 5000)
    },
    addSMessage (context, item) {
      const uid = new Date().getTime().toString(16) + Math.floor(1000 * Math.random()).toString(16)
      context.commit('add', Object.assign({}, item, {
        id: uid,
        type: 'info'
      }))
      setTimeout(() => {
        context.commit('close', uid)
      }, 3000)
    },
    addMessage (context, item) {
      const uid = new Date().getTime().toString(16) + Math.floor(1000 * Math.random()).toString(16)
      context.commit('add', Object.assign({}, item, {
        id: uid,
        type: 'info'
      }))
      setTimeout(() => {
        context.commit('close', uid)
      }, 10000)
    },
    addSSuccess (context, item) {
      const uid = new Date().getTime().toString(16) + Math.floor(1000 * Math.random()).toString(16)
      context.commit('add', Object.assign({}, item, {
        id: uid,
        type: 'success'
      }))
      setTimeout(() => {
        context.commit('close', uid)
      }, 3000)
    },
    addSuccess (context, item) {
      const uid = new Date().getTime().toString(16) + Math.floor(1000 * Math.random()).toString(16)
      context.commit('add', Object.assign({}, item, {
        id: uid,
        type: 'success'
      }))
      setTimeout(() => {
        context.commit('close', uid)
      }, 10000)
    },
    addProgress (context, item) {
      let uid = item.id ? item.id : new Date().getTime().toString(16) + Math.floor(1000 * Math.random()).toString(16)
      context.commit('add', Object.assign({}, item, {
        id: uid,
        type: 'progress'
      }))
    },
    updateProgress (context, item) {
      context.commit('update', item)
    },
    doneProgress (context, item) {
      context.commit('update', item)
      if (item.id) {
        setTimeout(() => {
          context.commit('close', item.id)
        }, 5000)
      }
    },
    closeProgress (context, id) {
      context.commit('close', id)
    }
  },
  getters: {
    list: (state) => () => {
      return state.items
    }
  }
}

export default new Vuex.Store({
  modules: {
    config: configModule,
    author: authorModule,
    client: clientModule,
    loader: loaderModule,
    notifier: notifierModule
  }
})
